module.exports = __webpack_public_path__ + "img/food.b034d1e7.svg";